/** Opt-in local synchronous work only; never includes props, IDs or network data. */
export type StartupWork = 'home.render' | 'table.render' | 'thumb.render' | 'spark.render';
let enabled = false;
let reuseRows = true;
const spans: Array<{ name: StartupWork; startMs: number; durationMs: number }> = [];
export function enableStartupWork(value: boolean, rowReuse = true): void { enabled = value; reuseRows = !value || rowReuse; spans.length = 0; }
/** Read-only diagnostic A/B; normal pages always keep reuse enabled. */
export function startupRowReuseEnabled(): boolean { return reuseRows; }
export function startupRowWidthKey(width: number | null): number | null { return reuseRows ? null : width; }
export function beginStartupWork(): number | undefined { return enabled ? performance.now() : undefined; }
export function finishStartupWork<T>(name: StartupWork, start: number | undefined, value: T): T {
  if (start !== undefined && enabled && spans.length < 512) {
    const end = performance.now();
    if (Number.isFinite(start) && Number.isFinite(end) && end >= start)
      spans.push({ name, startMs: Math.round(start * 10) / 10, durationMs: Math.round((end - start) * 10) / 10 });
  }
  return value;
}
export function startupWorkSnapshot() { return spans.map(span => ({ ...span })); }
